<template>
	<ListDetailLayout
			:store="devicesStore"
      index-route-name="admin.devices"
			create-permissions="create:devices"
			@on-create="$router.push({ name: 'admin.devices.device', params: { device: 'NEW' } })"
			@on-paginate="(page) => useOnPaginate(page, refreshDevices, params)"
			@on-search="(page) => useOnSearch(page, refreshDevices, params)"
      :filter="params.filter"
      @on-filter="({ filter }) => useOnFilter(filter, refreshDevices, params)"
	  create-button-admin-page="create-device-admin-btn"
	  search-admin-page="search-device-admin-page"
	>

		<template #list>
			<li v-for="device in devicesStore.getDevices" :key="device.id">
				<router-link :to="{ name: 'admin.devices.device', params: { device: device.id } }" v-slot="{isActive}">
					<div :class="[isActive ? 'border-primary-500 dark:bg-surface-600' : 'border-transparent hover:bg-surface-50 dark:hover:bg-surface-800', 'transition-colors border-l-4 flex items-center justify-between gap-x-6 py-5 pl-3 pr-4 bg-surface-0 dark:bg-surface-800']">

						<div class="min-w-0">
							<div class="flex items-start gap-x-3">
								<p class="text-sm font-semibold leading-6 text-surface-900 dark:text-surface-200">{{ device.serial_number }}</p>
								<!-- Show "Deleted" tag if the device is soft-deleted -->
								<span
									v-if="device.is_deleted"
									class="px-2 py-0.5 text-xs font-medium text-red-700 bg-red-100 rounded-md dark:bg-red-900 dark:text-red-200"
								>
									Deleted
								</span>
							</div>
							<div class="mt-1 flex items-center gap-x-2 text-xs leading-5 text-surface-500 dark:text-surface-400">
								<p class="whitespace-nowrap">
									{{ getSubHeading(device) }}
								</p>
							</div>
						</div>

					</div>
				</router-link>
			</li>
		</template>

		<template #detail>
				<router-view v-if="$route.params.device" @on-save="refreshDevices" @on-delete="refreshDevices"></router-view>
		</template>

	</ListDetailLayout>
</template>

<script>
import ListDetailLayout from "@/Layouts/ListDetailLayout.vue";
import Container from "@/Components/Container.vue";
import { mapStores } from "pinia";
import { useDevicesStore } from "@/stores/devices.js";
import {useOnFilter, useOnPaginate, useOnSearch} from "@/Composables/Pagination.js";

export default {
	name: "DevicesIndex",
	data() {
		return {
			params: {
        include: [
            'deviceType',
            'deviceModel',
            'deviceRevision',
        ],
        filter: {
          device_manufacturer_ids: [],
          device_type_ids: [],
          device_model_ids: [],
          device_revision_ids: [],
        }
      }
		}
	},
	methods: {
		useOnSearch,
		useOnPaginate,
    useOnFilter,
		refreshDevices(){
			return this.devicesStore.indexDevices(this.params);
		},
    getSubHeading(device){
      return [
          device.device_type?.name,
          device.device_model?.name,
          device.device_revision?.name
      ].filter(_ => _ !== null).join(' / ');
    }
	},
	components: {Container, ListDetailLayout},
	computed: {
		...mapStores(useDevicesStore)
	},
	async mounted() {
		await this.refreshDevices();
		// Listen for global refresh event after device recovery
		this.$root.$on('refresh-devices-list', () => {
			this.refreshDevices(false);
		});
	}
}
</script>